import { useId } from 'react';
import clsx from 'clsx';
import { RequestTimeline } from '../VacationRequestDetailsModal/components/RequestTimeline';
import { useVacationRequestEventsQuery } from '../../hooks/useVacationRequestEventsQuery';
import { buildVacationHistory } from '../../utils/vacationHistory';
import type { VacationRequest } from '../../models/vacation.types';
import type { VacationEvent } from '../../models/vacationEvent.types';

interface VacationEventHistoryProps {
  requestId?: string;
  request: VacationRequest | null | undefined;
  events?: VacationEvent[];
  className?: string;
}

export function VacationEventHistory({ requestId, request, events: providedEvents, className }: VacationEventHistoryProps) {
  const titleId = useId();
  const queried = useVacationRequestEventsQuery(providedEvents ? undefined : requestId);

  if (!request) return null;

  const events = providedEvents ?? queried.events;
  const isLoading = !providedEvents && queried.isLoading;
  const history = buildVacationHistory(request, events);

  return (
    <div className={clsx('space-y-2', className)}>
      <h4 id={titleId} className="text-sm font-semibold text-raro-gray-900 font-montserrat">Histórico</h4>
      {isLoading ? (
        <p className="text-sm text-raro-gray-500">Carregando histórico...</p>
      ) : history.length === 0 ? (
        <p className="text-sm text-raro-gray-500">Nenhum evento registrado</p>
      ) : (
        <RequestTimeline events={history} labelledBy={titleId} />
      )}
    </div>
  );
}
